export const STAGGER_PARENT = {
  show: {
    transition: {
      staggerChildren: 0.35,
      delayChildren: 0.2,
    },
  },
};

export const PROVIDING = {
  hidden: {
    x: "calc(10vw )",
    y: "100%",
  },
  show: {
    x: [null, "calc(10vw )", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.3,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const ACCURATE = {
  hidden: {
    x: "calc(-5vw)",
    y: "100%",
  },
  show: {
    x: [null, "calc(-5vw )", "calc(0vw )"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.4,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const AND = {
  hidden: {
    x: "calc(10vw)",
    y: "100%",
  },
  show: {
    x: [null, "calc(10vw)", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.5,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const TRUSTED = {
  hidden: {
    x: "calc(-5vw )",
    y: "100%",
  },
  show: {
    x: [null, "calc(-5vw  )", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.6,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const STATS = {
  hidden: {
    x: "calc(10vw)",
    y: "100%",
  },
  show: {
    x: [null, "calc(10vw)", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.7,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const TO = {
  hidden: {
    x: "calc(-5vw )",
    y: "100%",
  },
  show: {
    x: [null, "calc(-5vw  )", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.8,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const THE = {
  hidden: {
    x: "calc(5vw )",
    y: "100%",
  },
  show: {
    x: [null, "calc(5vw )", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 0.9,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
export const PUBLIC = {
  hidden: {
    x: "calc(10vw)",
    y: "100%",
  },
  show: {
    x: [null, "calc(10vw)", "calc(0vw)"],
    y: [null, "0%", "0%"],
    transition: {
      delay: 1.0,
      duration: 1.6,
      times: [0, 0.5, 1],
    },
  },
};
